(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9939],{

/***/ 28968:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing",
      function () {
        return __webpack_require__(94052);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 22737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19036);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98993);
/* harmony import */ var _services_utils_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70621);
/* harmony import */ var _services_zendesk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98763);





var Zendesk = function Zendesk(param) {
    var autoOpen = param.autoOpen, children = param.children, hasZendeskScriptLoaded = param.hasZendeskScriptLoaded, hasZendeskScriptLoadedAndDelayed = param.hasZendeskScriptLoadedAndDelayed, loadZendeskScript = param.loadZendeskScript, unmountCheck = param.unmountCheck, suppressHelpCenter = param.suppressHelpCenter;
    (0,_services_utils_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useMount */ .b6)(function() {
        if (!hasZendeskScriptLoaded) {
            loadZendeskScript();
        }
        return function() {
            if (unmountCheck() && window.zE) {
                window.zE("webWidget", "hide");
            }
        };
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (hasZendeskScriptLoaded && window.zE) {
            window.zE("webWidget", "updatePath");
            window.zE("webWidget", "show");
            // Define suppressions on mount. Don't undo on unmount since it may change the text
            // on the button while it is fading out. Better to only change it on mount for each
            // page.
            window.zE("webWidget", "updateSettings", {
                webWidget: {
                    helpCenter: {
                        suppress: !!suppressHelpCenter
                    }
                }
            });
            if (autoOpen) {
                window.zE("webWidget", "open");
            }
        }
    }, [
        autoOpen,
        hasZendeskScriptLoaded,
        suppressHelpCenter
    ]);
    if (typeof children === "function") {
        return children({
            loading: !hasZendeskScriptLoaded,
            hasLoadedAndDelayed: hasZendeskScriptLoadedAndDelayed
        });
    }
    return null;
};
Zendesk.propTypes = {
    autoOpen: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().bool),
    hasZendeskScriptLoaded: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().bool),
    hasZendeskScriptLoadedAndDelayed: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().bool),
    loadZendeskScript: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().func.isRequired),
    unmountCheck: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().func),
    suppressHelpCenter: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().bool),
    children: prop_types__WEBPACK_IMPORTED_MODULE_0___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_0___default().func),
        (prop_types__WEBPACK_IMPORTED_MODULE_0___default().node)
    ])
};
Zendesk.defaultProps = {
    unmountCheck: function unmountCheck() {
        return true;
    }
};
var mapStateToProps = function mapStateToProps(state) {
    return {
        hasZendeskScriptLoaded: _services_zendesk__WEBPACK_IMPORTED_MODULE_4__/* .zendeskSelectors.hasZendeskScriptLoaded */ .U.hasZendeskScriptLoaded(state),
        hasZendeskScriptLoadedAndDelayed: _services_zendesk__WEBPACK_IMPORTED_MODULE_4__/* .zendeskSelectors.hasZendeskScriptLoadedAndDelayed */ .U.hasZendeskScriptLoadedAndDelayed(state)
    };
};
var mapDispatchToProps = {
    loadZendeskScript: _services_zendesk__WEBPACK_IMPORTED_MODULE_4__/* .zendeskActions.loadZendeskScript */ .I.loadZendeskScript
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(Zendesk));


/***/ }),

/***/ 55804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77637);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99797);



var usePageTrack = function usePageTrack(_param) {
    var name = _param.name, category = _param.category, extraProperties = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "name",
        "category"
    ]);
    var hasAlreadyFiredRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (hasAlreadyFiredRef.current) {
            return;
        }
        ___WEBPACK_IMPORTED_MODULE_1__/* ["default"].page */ .ZP.page(category, name, extraProperties);
        hasAlreadyFiredRef.current = true;
    }, [
        category,
        name,
        extraProperties
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePageTrack);


/***/ }),

/***/ 98763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* reexport */ actions; },
  "U": function() { return /* reexport */ selectors; }
});

// EXTERNAL MODULE: ./workspaces/app/static/main/src/store/index.js + 3 modules
var store = __webpack_require__(91472);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(57389);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/redux-actions@2.3.2/node_modules/redux-actions/es/index.js + 75 modules
var es = __webpack_require__(35328);
;// CONCATENATED MODULE: ./workspaces/app/static/main/src/services/zendesk/zendesk.ducks.js




var actionTypes = {
    ZENDESK_SCRIPT_LOAD: "zendesk/script/load",
    ZENDESK_SCRIPT_LOADED: "zendesk/script/loaded",
    ZENDESK_SCRIPT_LOADED_AND_DELAYED: "zendesk/script/loaded_and_delayed",
    WIDGET_OPENED: "zendesk/widget/opened",
    WIDGET_CLOSED: "zendesk/widget/closed"
};
var actions = {
    loadZendeskScript: (0,es/* createAction */.PH)(actionTypes.ZENDESK_SCRIPT_LOAD),
    zendeskScriptLoaded: (0,es/* createAction */.PH)(actionTypes.ZENDESK_SCRIPT_LOADED),
    zendeskScriptLoadedAndDelayed: (0,es/* createAction */.PH)(actionTypes.ZENDESK_SCRIPT_LOADED_AND_DELAYED),
    widgetOpened: (0,es/* createAction */.PH)(actionTypes.WIDGET_OPENED),
    widgetClosed: (0,es/* createAction */.PH)(actionTypes.WIDGET_CLOSED)
};
var initialState = {
    hasZendeskScriptLoaded: false,
    hasZendeskScriptLoadedAndDelayed: false,
    isWidgetOpen: false
};
var _obj;
var reducer = (0,es/* handleActions */.jZ)((_obj = {}, (0,_define_property/* default */.Z)(_obj, actionTypes.ZENDESK_SCRIPT_LOADED, function(state) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
        hasZendeskScriptLoaded: true
    });
}), (0,_define_property/* default */.Z)(_obj, actionTypes.ZENDESK_SCRIPT_LOADED_AND_DELAYED, function(state) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
        hasZendeskScriptLoadedAndDelayed: true
    });
}), (0,_define_property/* default */.Z)(_obj, actionTypes.WIDGET_OPENED, function(state) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
        isWidgetOpen: true
    });
}), (0,_define_property/* default */.Z)(_obj, actionTypes.WIDGET_CLOSED, function(state) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
        isWidgetOpen: false
    });
}), _obj), initialState);
var selectors = {
    hasZendeskScriptLoaded: function hasZendeskScriptLoaded(state) {
        return state.zendesk.hasZendeskScriptLoaded;
    },
    hasZendeskScriptLoadedAndDelayed: function hasZendeskScriptLoadedAndDelayed(state) {
        return state.zendesk.hasZendeskScriptLoadedAndDelayed;
    },
    isWidgetOpen: function isWidgetOpen(state) {
        return state.zendesk.isWidgetOpen;
    }
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9970);
// EXTERNAL MODULE: ./node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/observable/from.js + 6 modules
var from = __webpack_require__(22376);
// EXTERNAL MODULE: ./node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/observable/merge.js + 1 modules
var merge = __webpack_require__(37872);
// EXTERNAL MODULE: ./node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/observable/of.js
var of = __webpack_require__(20731);
// EXTERNAL MODULE: ./node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/observable/fromEventPattern.js
var fromEventPattern = __webpack_require__(41079);
// EXTERNAL MODULE: ./node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/tap.js + 1 modules
var tap = __webpack_require__(85767);
// EXTERNAL MODULE: ./node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/mergeMap.js
var mergeMap = __webpack_require__(71059);
// EXTERNAL MODULE: ./node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/map.js
var map = __webpack_require__(73152);
// EXTERNAL MODULE: ./node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/filter.js
var filter = __webpack_require__(34758);
// EXTERNAL MODULE: ./node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/ignoreElements.js
var ignoreElements = __webpack_require__(64999);
// EXTERNAL MODULE: ./node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/switchMap.js
var switchMap = __webpack_require__(72044);
// EXTERNAL MODULE: ./node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/delay.js + 1 modules
var delay = __webpack_require__(61945);
// EXTERNAL MODULE: ./node_modules/.pnpm/i18next@19.8.4/node_modules/i18next/dist/esm/i18next.js + 10 modules
var i18next = __webpack_require__(12693);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/constants/index.ts + 1 modules
var constants = __webpack_require__(90049);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/services/translation/constants.js
var translation_constants = __webpack_require__(89523);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/services/user/index.js + 3 modules
var user = __webpack_require__(78807);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/services/utils/index.ts + 1 modules
var utils = __webpack_require__(78723);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/static/styles/theme.ts + 1 modules
var theme = __webpack_require__(72629);
;// CONCATENATED MODULE: ./workspaces/app/static/main/src/services/zendesk/zendesk.epics.js



// eslint-disable-next-line no-restricted-imports








var loadZendesk = function loadZendesk() {
    return new Promise(function(resolve) {
        var existingScript = document.getElementById("ze-snippet");
        if (!existingScript) {
            var script = document.createElement("script");
            script.nonce = window.SCRIPT_NONCE;
            script.id = "ze-snippet";
            script.onload = function() {
                // ensure that window.zE is actually present before we resolve
                if (window.zE) {
                    resolve();
                }
            };
            script.src = "https://static.zdassets.com/ekr/snippet.js?key=".concat(constants/* ZENDESK_PUBLIC_ID */.IrN);
            document.body.appendChild(script);
        }
        // ensure that window.zE is actually present before we resolve
        if (window.zE) {
            resolve();
        }
    });
};
var loadZendeskScript = function loadZendeskScript(action$) {
    return action$.ofType(actionTypes.ZENDESK_SCRIPT_LOAD).pipe((0,tap/* tap */.b)(function() {
        // These settings are used when the widget is loaded. Need to use the window.zE()
        // API to make updates after it has loaded.
        window.zESettings = {
            webWidget: {
                chat: {
                    // Hide the departments selection
                    departments: {
                        enabled: []
                    }
                },
                // Note that the button has 16x24 px padding, so 0, 0 isn't actually in the
                // absolute bottom corner
                offset: {
                    horizontal: "0px",
                    vertical: "0px"
                },
                zIndex: theme/* default.zIndex.zendeskWidget */.Z.zIndex.zendeskWidget
            }
        };
    }), (0,mergeMap/* mergeMap */.zg)(function() {
        return (0,from/* from */.D)(loadZendesk()).pipe((0,map/* map */.U)(actions.zendeskScriptLoaded));
    }));
};
var addUserToZendesk = function addUserToZendesk(action$, store) {
    return action$.ofType(actionTypes.ZENDESK_SCRIPT_LOADED).pipe((0,map/* map */.U)(function() {
        return user/* userSelectors.getEmail */.py.getEmail(store.value);
    }), (0,filter/* filter */.h)(function(email) {
        return email;
    }), (0,tap/* tap */.b)(function(email) {
        if (window.zE) {
            window.zE("webWidget", "identify", {
                email: email
            });
            window.zE("webWidget", "prefill", {
                email: {
                    value: email,
                    readOnly: true
                }
            });
        }
    }), (0,ignoreElements/* ignoreElements */.l)());
};
var setZendeskLanguage = function setZendeskLanguage(action$) {
    return action$.ofType(actionTypes.ZENDESK_SCRIPT_LOADED).pipe((0,switchMap/* switchMap */.w)(function() {
        return (0,merge/* merge */.T)((0,of.of)(1), (0,fromEventPattern/* fromEventPattern */.R)(function(handler) {
            return i18next/* default.on */.Z.on("languageChanged", handler);
        }, function(handler) {
            return i18next/* default.off */.Z.off("languageChanged", handler);
        })).pipe((0,tap/* tap */.b)(function() {
            if (i18next/* default.language */.Z.language && window.zE) {
                window.zE("webWidget", "setLocale", translation_constants/* I18N_ZENDESK_LOCALES */.fw[i18next/* default.language */.Z.language]);
            }
        }), (0,ignoreElements/* ignoreElements */.l)());
    }));
};
function zendeskEventFactory(eventName) {
    var zE = window.zE || utils/* noop */.ZT;
    var hasRemovedListener = false;
    return (0,fromEventPattern/* fromEventPattern */.R)(function(handler) {
        zE("webWidget:on", eventName, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return !hasRemovedListener && handler.apply(void 0, (0,_to_consumable_array/* default */.Z)(args));
        });
    }, function() {
        hasRemovedListener = true;
    });
}
var addZendeskListeners = function addZendeskListeners(action$) {
    return action$.ofType(actionTypes.ZENDESK_SCRIPT_LOADED).pipe((0,switchMap/* switchMap */.w)(function() {
        return (0,merge/* merge */.T)(zendeskEventFactory("open").pipe((0,map/* map */.U)(function() {
            return actions.widgetOpened();
        })), zendeskEventFactory("close").pipe((0,map/* map */.U)(function() {
            return actions.widgetClosed();
        })));
    }));
};
// The Zendesk widget isn't actually visible until about 1-2 secs after the script has loaded.
// Let's debounce the event so loading states are maintained for a little longer even after
// the script has loaded.
var debounceZendeskLoadEvent = function debounceZendeskLoadEvent(action$) {
    return action$.ofType(actionTypes.ZENDESK_SCRIPT_LOADED).pipe((0,delay/* delay */.g)(1000), (0,map/* map */.U)(function() {
        return actions.zendeskScriptLoadedAndDelayed();
    }));
};
/* harmony default export */ var zendesk_epics = ((0,store/* combineEpicsWithCatches */.Q0)(loadZendeskScript, addUserToZendesk, setZendeskLanguage, addZendeskListeners, debounceZendeskLoadEvent));

;// CONCATENATED MODULE: ./workspaces/app/static/main/src/services/zendesk/index.js



(0,store/* injectEpic */.oe)(zendesk_epics);
(0,store/* injectReducer */.fn)("zendesk", reducer);



/***/ }),

/***/ 75371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ssrAdapter_components_useIHeartTracking; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./workspaces/app/static/main/src/components/useIHeartTracking/index.ts

var useIHeartTracking = function useIHeartTracking(param) {
    var action = param.action;
    (0,react.useEffect)(function() {
        var pixel = document.createElement("img");
        var params = new URLSearchParams();
        params.append("ad_log", "referer");
        if (action) {
            params.append("action", action);
        }
        params.append("pixid", "dfd0fbd9-e7bd-4f9b-83ca-25f7bee979d8");
        pixel.src = "https://arttrk.com/pixel/?".concat(params.toString());
        pixel.width = 1;
        pixel.height = 1;
        pixel.style.position = "fixed";
        pixel.alt = "";
        document.body.appendChild(pixel);
        return function() {
            document.body.removeChild(pixel);
        };
    }, [
        action
    ]);
    return null;
};
/* harmony default export */ var components_useIHeartTracking = (useIHeartTracking);

;// CONCATENATED MODULE: ./workspaces/app/static/main/src/ssrAdapter/components/useIHeartTracking.js

/* harmony default export */ var ssrAdapter_components_useIHeartTracking = (components_useIHeartTracking);


/***/ }),

/***/ 94052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pricing; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.7.2/node_modules/prop-types/index.js
var prop_types = __webpack_require__(19036);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@8.1.2_ypdvb6du3tmuwvd75cbb5hw34i/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(98993);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/ssrAdapter/react-router-dom.tsx + 3 modules
var react_router_dom = __webpack_require__(72608);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/Marketing/index.ts + 38 modules
var Marketing = __webpack_require__(79593);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/Pricing/index.js + 54 modules
var components_Pricing = __webpack_require__(35843);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/Zendesk/index.js
var Zendesk = __webpack_require__(22737);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/constants/index.ts + 1 modules
var constants = __webpack_require__(90049);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/constants/featureFlags.js
var featureFlags = __webpack_require__(80513);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/services/analytics/index.ts + 2 modules
var analytics = __webpack_require__(99797);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/services/analytics/usePageTrack.js
var usePageTrack = __webpack_require__(55804);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/services/locale/index.js + 4 modules
var locale = __webpack_require__(38959);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/services/signup/index.js + 3 modules
var signup = __webpack_require__(43570);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/services/login/index.js + 2 modules
var login = __webpack_require__(84872);
;// CONCATENATED MODULE: ./workspaces/app/static/main/src/scenes/Pricing/index.js















var Pricing = function Pricing(param) {
    var planType = param.planType;
    var dispatch = (0,es/* useDispatch */.I0)();
    var history = (0,react_router_dom/* useHistory */.k6)();
    var currency = (0,es/* useSelector */.v9)(locale/* localeSelectors.getCurrency */.F5.getCurrency);
    (0,usePageTrack/* default */.Z)({
        name: analytics/* default.events.PRICING */.ZP.events.PRICING,
        category: analytics/* default.events.category.MARKETING */.ZP.events.category.MARKETING,
        currency: currency
    });
    var onChoosePlan = (0,react.useCallback)(function(param) {
        var plan = param.plan, planInterval = param.planInterval, source = param.source;
        analytics/* default.track */.ZP.track(analytics/* default.events.PRICING_TABLE_SIGNUP_CLICKED */.ZP.events.PRICING_TABLE_SIGNUP_CLICKED, {
            plan: plan,
            planInterval: planInterval,
            source: source
        });
        if (plan === constants/* PLANS.BUSINESS */.Xf4.BUSINESS) {
            history.push("/contact-sales");
            return;
        }
        if (plan !== constants/* PLANS.FREE */.Xf4.FREE && featureFlags/* default.signupPricingRedirect */.Z.signupPricingRedirect) {
            dispatch(signup/* signupActions.setPostSignupRedirectUrl */.FA.setPostSignupRedirectUrl({
                url: "/plan/confirm/".concat(plan, "/").concat(planInterval)
            }));
            dispatch(login/* loginActions.setPostLoginRedirectUrl */.B.setPostLoginRedirectUrl({
                url: "/plan/confirm/".concat(plan, "/").concat(planInterval)
            }));
        }
        history.push("/signup");
    }, [
        dispatch,
        history
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        role: "main",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Zendesk/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Pricing/* PricingHero */.yx, {
                onChoosePlan: onChoosePlan,
                planType: planType
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Pricing/* PricingBrandsBanner */.g1, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketing/* TestimonialCarousel */.NM, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Pricing/* FrequentlyAskedQuestions */.PN, {})
        ]
    });
};
Pricing.propTypes = {
    planType: (prop_types_default()).string
};
/* harmony default export */ var scenes_Pricing = (Pricing);

;// CONCATENATED MODULE: ./workspaces/app/static/main/src/ssrAdapter/pages/PricingPage.js

/* harmony default export */ var PricingPage = (scenes_Pricing);

// EXTERNAL MODULE: ./src/components/templates/MarketingTemplate/index.ts + 7 modules
var MarketingTemplate = __webpack_require__(90539);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/ssrAdapter/components/useIHeartTracking.js + 1 modules
var useIHeartTracking = __webpack_require__(75371);
;// CONCATENATED MODULE: ./src/pages/pricing.tsx




var pricing_Pricing = function(param) {
    var featureFlags = param.featureFlags, navigation = param.navigation, planType = param.planType, user = param.user;
    (0,useIHeartTracking/* default */.Z)({
        action: "purchase"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingTemplate/* default */.Z, {
        activePage: "/pricing",
        featureFlags: featureFlags,
        navigation: navigation,
        overflowVisible: true,
        topPadding: false,
        user: user,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingPage, {
            planType: planType
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var pricing = (pricing_Pricing);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4621,1944,8869,3413,9101,9779,9984,2682,1724,5646,7885,7994,8936,539,7401,8304,5843,9774,2888,179], function() { return __webpack_exec__(28968); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);